import { debounce } from '../../utils/lodash-replacements';
import initImageCarousel from './initImageCarousel';
import initContentCarousel from './initContentCarousel';
import initMobileCarousel from './initMobileCarousel';

export default class {
  constructor(el) {
    this.el = el;
    this.imageCarousels = [];
    this.contentCarousel = null;
    this.mobileCarousel = null;

    this.init = this.init.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.updateImageSlides = this.updateImageSlides.bind(this);

    this.init();

    window.addEventListener(
      'resize',
      debounce(() => {
        this.handleResize();
      }, 500),
    );

    document.addEventListener('shopify:section:load', () => {
      this.destroy();
      this.init();
    });
  }

  init() {
    const contentCarouselEl = this.el.querySelector('[data-hero-dual-image-content-carousel]');
    const mobileCarouselEl = this.el.querySelector('[data-hero-dual-image-content-carousel-mobile]');

    this.imageCarousels = [];
    this.el.querySelectorAll('[data-hero-dual-image-carousel]').forEach((el) => {
      const carousel = initImageCarousel(el);
      if (carousel) this.imageCarousels.push(carousel);
    });

    // The content carousel is the only one the visitor drives; its change event
    // pulls both image strips along. ScrollCarousel takes its consumer
    // callbacks up front via `on`, so the handler is passed at construction
    // rather than attached afterwards.
    this.contentCarousel = initContentCarousel(contentCarouselEl, {
      change: this.updateImageSlides,
    });

    this.mobileCarousel = initMobileCarousel(mobileCarouselEl);
  }

  destroy() {
    try {
      this.imageCarousels.forEach((carousel) => {
        carousel.destroy();
      });
      this.imageCarousels = [];

      if (this.contentCarousel) this.contentCarousel.destroy();
      if (this.mobileCarousel) this.mobileCarousel.destroy();
      this.contentCarousel = null;
      this.mobileCarousel = null;
    } catch (error) {
      console.log(error);
    }
  }

  handleResize() {
    this.destroy();
    this.init();
  }

  /**
   * Keep the two image strips on the same slide as the content overlay.
   *
   * NOTE: this read `this.image_carousels` — a typo for `this.imageCarousels`,
   * which `init()` actually assigns. Optional chaining swallowed it, so the
   * whole body has been a no-op and the image strips never followed the
   * content carousel. Fixing the property name activates this code for the
   * first time. Ref. WIN-8070.
   *
   * The stepping below (`next`/`previous` at the seam instead of `select`) is
   * what keeps the wrap looking continuous rather than sweeping back across
   * every slide. The `num <= 2` branch is a known-wrong special case, kept
   * as-is per the original comment.
   */
  updateImageSlides(i) {
    this.imageCarousels?.forEach((carousel) => {
      const ind = carousel.selectedIndex;
      // Was `carousel.cells.length`, a Flickity internal. `realCount` is the
      // equivalent: slides excluding the loop clones.
      const num = carousel.realCount;

      // Wrapping doesn't work right if there's only 2
      // Not sure how to fix this
      if (num <= 2) {
        carousel.select(i);
        return;
      }

      if (ind === num - 1 && i === 0) {
        carousel.next();
      } else if (ind === 0 && i === num - 1) {
        carousel.previous();
      } else {
        carousel.select(i);
      }
    });
  }
}
